exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span {\n  color: #d9534f;\n  cursor: pointer;\n  float: right;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/import/import-error/import-error.component.scss
// module id = ../../../../../src/app/import/import-error/import-error.component.scss
// module chunks = main